export default [
  {
    path: 'act-change-report/:actId',
    name: 'actChangeReport',
    component: () => import('@/views/Act/ActChangeReport/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'acts',
    },
  },
  {
    path: 'printing/act_change_report/:actId',
    name: 'PrintingActChangeReport',
    component: () => import('@/views/Printing/ActChangeReport.vue'),
    props: true,
    meta: {
      name: 'printing-act-change-report',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'printing/act-library',
    name: 'PrintingActLibrary',
    component: () => import('@/views/Printing/ActLibrary.vue'),
    props: true,
    meta: {
      name: 'printing-act-library',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'acts',
    name: 'acts',
    component: () => import('@/views/Act/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'acts',
      template: 'auth',
    },
  },
  {
    path: 'act-content-main/:act_id',
    name: 'actContent',
    component: () => import('@/views/Act/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'acts',
    },
  },
  {
    path: 'act-change-report-content/:actId',
    name: 'actChangeReportContent',
    component: () => import('@/views/Act/ActChangeReport/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'acts',
    },
  },
  {
    path: 'print-act-change-report/:actId',
    name: 'printActChangeReport',
    component: () => import('@/views/Printing/ActChangeReport.vue'),
    props: true,
    meta: {
      name: 'printActChangeReport',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'print-act-library',
    name: 'printActLibrary',
    component: () => import('@/views/Printing/ActLibrary.vue'),
    props: true,
    meta: {
      name: 'printActLibrary',
      middleware: 'auth',
      template: 'printing',
    },
  },
];
